export default "__VITE_ASSET__2bb134a5__"